import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

const baseRef = 'entidade-documento';
const route = {
  deletarArquivo: (id: number) => `${baseRef}/${id}`
};

@Injectable({
  providedIn: 'root'
})
export class EntidadeDocumentoService {

  constructor(private apiService: ApiService) {}

  deletarArquivo(id: number): Observable<any> {
    return this.apiService.delete<void>(`${route.deletarArquivo(id)}`);
  }

}
